// extracted by mini-css-extract-plugin
module.exports = {"phase":"phase__4TZ37","completed":"completed__14QQR"};